import {
    GET_LIST_CUSTOMER_TELESALE,
    GET_LIST_CUSTOMER_TELESALE_BY_CUSTOMER
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    customerTelesaleList: [],
    customerCareList: [],  // <-- thêm đây
    statistical: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_TELESALE: {
            return {
                ...state,
                customerTelesaleList: action.payload?.data || [],
                statistical: action.payload.statistical,
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }

        case GET_LIST_CUSTOMER_TELESALE_BY_CUSTOMER: {
            return {
                ...state,
                customerCareList: action.payload || []
            }
        }

        default:
            return { ...state };
    }
};
